import React, {useEffect, useState} from 'react';

import {MeetingLayout, MeetingLayoutLoading} from '@pexip/media-components';

import {useCurrentHostLayout, useMeetingContext} from '../hooks/meeting';
import {useInfinityClient} from '../hooks/useInfinityContext';
import {useMe} from '../hooks/useMe';

const BASE_COLOR = '#FFFFFF';
const PRIMARY_COLOR = '#777777';
const ACTIVE_COLOR = '#0068F4';

// FIXME: this is all super hacky, first repalce we have because we cant override the color in the img tag,
// 2nd is to escape `#` as otherwise we cant get xml to load
// An alternative would be to load svg directly to the DOM, but then we execute some code we get from the API which isnt ideal?
const getSource = (source: string, color: string) =>
    source &&
    `data:image/svg+xml,${source.replaceAll('currentColor', BASE_COLOR).replaceAll('#BBBFC3', color)}`.replaceAll(
        '#',
        '%23',
    );

const getLayouts = (
    layouts: Record<string, string> | undefined,
    availableLayouts: {name: string}[],
) =>
    new Map(
        Object.entries(layouts ?? {}).flatMap(([name, source]) =>
            availableLayouts.some(layout => layout.name === name)
                ? [
                      [
                          name,
                          {
                              primary: getSource(source, PRIMARY_COLOR),
                              active: getSource(source, ACTIVE_COLOR),
                          },
                      ],
                  ]
                : [],
        ),
    );

export const Layouts: React.FC<{
    isConfirmationOpen: boolean;
    openConfirmation: () => void;
    closeConfirmation: () => void;
    close: (e: React.SyntheticEvent<HTMLElement>) => void;
}> = ({isConfirmationOpen, openConfirmation, closeConfirmation, close}) => {
    const meeting = useMeetingContext();
    const infinityClient = useInfinityClient();
    const me = useMe(meeting.getMe);
    const currentHostLayout = useCurrentHostLayout(
        meeting.getCurrentHostLayout,
    );

    const [layouts, setLayouts] =
        useState<Map<string, {primary: string; active: string}>>();

    useEffect(() => {
        const getAvailableLayouts = async () => {
            try {
                const availableLayouts = await infinityClient.availableLayouts(
                    {},
                );
                if (!availableLayouts) {
                    throw new Error('No available layouts found');
                }
                const normalizedLayouts = availableLayouts.map(layout =>
                    typeof layout === 'string' ? {name: layout} : layout,
                );
                setLayouts(
                    getLayouts(
                        await infinityClient.layoutSvgs({}),
                        normalizedLayouts ?? [],
                    ),
                );
            } catch (_e) {
                setLayouts(new Map());
            }
        };

        void getAvailableLayouts();
    }, [infinityClient]);

    if (!layouts) {
        return <MeetingLayoutLoading />;
    }

    return (
        <MeetingLayout
            canChangeLayout={me?.canChangeLayout}
            canChangePersonalLayout={me?.canReceivePersonalMix}
            currentLayout={currentHostLayout}
            currentPersonalLayout={
                me?.receiveFromVideoMix?.mix_config?.transform_layout?.layout
            }
            setLayout={meeting.changeLayout}
            setPersonalLayout={meeting.changePersonalLayout}
            resetToMeetingLayout={meeting.resetToMeetingLayout}
            isConfirmationOpen={isConfirmationOpen}
            openConfirmation={openConfirmation}
            closeConfirmation={closeConfirmation}
            layouts={layouts}
            close={close}
        />
    );
};
